(function () {
  'use strict';

  function norm(value) {
    return String(value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  function getLang() {
    return norm(document.documentElement.lang || window.Shopify && Shopify.locale || 'es');
  }

  function t(key) {
    var lang = getLang();
    var de = lang.indexOf('de') === 0;
    var dict = {
      title: de ? 'Größenberater' : 'Guía de talla',
      intro: de ? 'Introduce tu altura para calcular la talla recomendada.' : 'Introduce tu altura para calcular la talla recomendada.',
      height: de ? 'Altura' : 'Altura',
      recommended: de ? 'Empfohlene Größe' : 'Talla recomendada',
      forHeight: de ? 'Para una altura de' : 'Para una altura de',
      yourSize: de ? 'tu talla sería la' : 'tu talla sería la',
      close: de ? 'Schließen' : 'Cerrar',
      noData: de ? 'No hay datos suficientes para calcular la talla.' : 'No hay datos suficientes para calcular la talla.',
      choose: de ? 'Seleccionar talla recomendada' : 'Seleccionar talla recomendada'
    };
    return dict[key] || key;
  }

  function sizeRange(size) {
    var k = norm(size).replace(/ /g, '');
    var map = {
      xxs: [145, 155], xs: [150, 160], s: [160, 170], m: [170, 180], l: [180, 190], xl: [190, 200], xxl: [200, 210],
      '48': [157, 167], '51': [165, 175], '54': [170, 180], '56': [175, 185], '58': [182, 193], '61': [190, 203]
    };
    return map[k] || null;
  }

  function collectSizeData(root) {
    return Array.prototype.slice.call(root.querySelectorAll('.lbx-size-button')).map(function (button) {
      var value = button.getAttribute('data-lbx-option-value') || (button.querySelector('strong') && button.querySelector('strong').textContent) || '';
      var text = button.querySelector('[data-lbx-size-card-range]') ? button.querySelector('[data-lbx-size-card-range]').textContent : '';
      var m = String(text).match(/(\d{2,3})\s*[–-]\s*(\d{2,3})/);
      var range = m ? [Number(m[1]), Number(m[2])] : sizeRange(value);
      return { value: String(value).trim(), range: range, button: button, available: !button.disabled && !button.classList.contains('is-disabled') };
    }).filter(function (x) { return x.value; });
  }

  function recommend(items, height) {
    if (!items.length) return null;
    var ranged = items.filter(function (x) { return x.range; });
    if (!ranged.length) return items[0];
    var available = ranged.filter(function (x) { return x.available; });
    var pool = available.length ? available : ranged;
    var exact = pool.filter(function (x) { return height >= x.range[0] && height <= x.range[1]; });
    if (exact.length) return exact[0];
    return pool.sort(function (a, b) {
      var ac = (a.range[0] + a.range[1]) / 2;
      var bc = (b.range[0] + b.range[1]) / 2;
      return Math.abs(ac - height) - Math.abs(bc - height);
    })[0];
  }

  function ensureModal(root) {
    var modal = root.querySelector('[data-lbx-size-guide-modal]');
    if (modal) return modal;
    modal = document.createElement('div');
    modal.className = 'lbx-size-guide-modal';
    modal.setAttribute('data-lbx-size-guide-modal', '');
    modal.hidden = true;
    modal.innerHTML = '<div class="lbx-size-guide-backdrop" data-lbx-v25-size-close></div><div class="lbx-size-guide-dialog" role="dialog" aria-modal="true"><button type="button" class="lbx-size-guide-close" data-lbx-v25-size-close aria-label="' + t('close') + '">×</button><div class="lbx-size-guide-header"><div class="lbx-size-guide-eyebrow">' + t('title') + '</div><h2 class="lbx-size-guide-title">' + t('title') + '</h2><p class="lbx-size-guide-subtitle">' + t('intro') + '</p></div><div class="lbx-size-guide-top"><div class="lbx-size-guide-card"><label class="lbx-size-guide-field"><span>' + t('height') + '</span><input class="lbx-size-guide-input" type="number" min="120" max="230" value="175" data-lbx-v25-height></label></div><div class="lbx-size-guide-result" data-lbx-v25-result></div></div><div class="lbx-size-guide-table" data-lbx-v25-table></div></div>';
    root.appendChild(modal);
    return modal;
  }

  function renderModal(root, modal) {
    var input = modal.querySelector('[data-lbx-v25-height], [data-lbx-height-input]');
    var result = modal.querySelector('[data-lbx-v25-result], [data-lbx-size-guide-result]');
    var table = modal.querySelector('[data-lbx-v25-table], [data-lbx-size-guide-table]');
    if (!result) return;
    var items = collectSizeData(root);
    var height = Number(input && input.value ? input.value : 175);
    if (!height || height < 120 || height > 230) height = 175;
    var rec = recommend(items, height);
    if (!rec) {
      result.textContent = t('noData');
      if (table) table.innerHTML = '';
      return;
    }
    result.innerHTML = '<span class="lbx-size-guide-result-label">' + t('recommended') + '</span><span class="lbx-size-guide-result-size">' + rec.value + '</span><span>' + t('forHeight') + ' <strong>' + height + ' cm</strong>, ' + t('yourSize') + ' <strong>' + rec.value + '</strong>.</span>';
    if (table) {
      table.innerHTML = items.map(function (item) {
        var range = item.range ? item.range[0] + '–' + item.range[1] + ' cm' : '';
        return '<div class="lbx-size-guide-row' + (rec.value === item.value ? ' is-recommended' : '') + '"><div class="lbx-size-guide-size">' + item.value + '</div><div class="lbx-size-guide-scale"><span style="display:block;padding:16px 0;color:#697080;font-size:13px;">' + range + '</span></div></div>';
      }).join('');
    }
  }

  function openSizeGuide(button) {
    var root = button.closest('[id^="lbx-product-"]');
    if (!root) return;
    var modal = ensureModal(root);
    renderModal(root, modal);
    modal.hidden = false;
    modal.style.display = 'flex';
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('lbx-v25-modal-open');
    var input = modal.querySelector('[data-lbx-v25-height], [data-lbx-height-input]');
    if (input && !input.__lbxV25) {
      input.__lbxV25 = true;
      input.addEventListener('input', function () { renderModal(root, modal); });
    }
  }

  function closeSizeGuide(el) {
    var modal = el.closest('[data-lbx-size-guide-modal]');
    if (!modal) return;
    modal.hidden = true;
    modal.style.display = 'none';
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('lbx-v25-modal-open');
  }

  document.addEventListener('click', function (event) {
    var open = event.target.closest && event.target.closest('[data-lbx-size-guide-open]');
    if (open) {
      event.preventDefault();
      event.stopPropagation();
      openSizeGuide(open);
      return;
    }
    var close = event.target.closest && event.target.closest('[data-lbx-v25-size-close], [data-lbx-size-guide-close]');
    if (close) {
      event.preventDefault();
      closeSizeGuide(close);
    }
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var modal = document.querySelector('[data-lbx-size-guide-modal]:not([hidden])');
    if (modal) closeSizeGuide(modal);
  });

  var colorKeywords = {
    brown: ['brown', 'braun', 'marron', 'marrón', 'copper', 'cobre', 'bronze', 'chocolate', 'mocha'],
    green: ['green', 'grun', 'grün', 'verde', 'olive', 'oliva', 'poolgreen'],
    blue: ['blue', 'blau', 'azul', 'navy', 'bluegreen'],
    black: ['black', 'schwarz', 'negro', 'antracita', 'anthracite', 'graphite', 'grafito'],
    white: ['white', 'weiss', 'weiß', 'blanco', 'cream', 'crema'],
    red: ['red', 'rot', 'rojo'],
    orange: ['orange', 'naranja'],
    grey: ['grey', 'gray', 'grau', 'gris', 'silver', 'plata'],
    yellow: ['yellow', 'gelb', 'amarillo', 'gold', 'dorado'],
    purple: ['purple', 'violet', 'lila', 'morado', 'violeta'],
    pink: ['pink', 'rosa']
  };

  function keywordsFor(value) {
    var v = norm(value);
    var keys = [];
    Object.keys(colorKeywords).forEach(function (family) {
      colorKeywords[family].forEach(function (word) {
        if (v.indexOf(norm(word)) !== -1 || norm(word).indexOf(v) !== -1) keys = keys.concat(colorKeywords[family]);
      });
    });
    if (!keys.length && v) keys.push(v);
    return keys.map(norm).filter(Boolean);
  }

  function updateGalleryByColor(root) {
    var active = root.querySelector('.lbx-color-button.is-active');
    if (!active) return;
    var color = active.getAttribute('data-lbx-option-value') || active.getAttribute('title') || '';
    var keys = keywordsFor(color);
    if (!keys.length) return;
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-lbx-thumbnail]'));
    if (!thumbs.length) return;
    var matches = thumbs.filter(function (button) {
      var img = button.querySelector('img');
      var hay = norm([button.getAttribute('data-image-alt'), button.getAttribute('data-image-src'), img && img.getAttribute('src'), img && img.getAttribute('alt')].join(' '));
      return keys.some(function (k) { return hay.indexOf(k) !== -1; });
    });
    // Best practice: only filter if product media contains usable color metadata.
    // If it does not, keep all images to avoid hiding valid product media.
    if (matches.length < 1) {
      thumbs.forEach(function (button) { button.removeAttribute('data-lbx-v25-hidden'); button.hidden = false; button.style.display = ''; });
      return;
    }
    thumbs.forEach(function (button) {
      var show = matches.indexOf(button) !== -1;
      button.setAttribute('data-lbx-v25-hidden', show ? 'false' : 'true');
      button.hidden = !show;
      button.style.display = show ? '' : 'none';
    });
    var first = matches[0];
    if (first && !first.classList.contains('is-active')) {
      setTimeout(function () { first.click(); }, 40);
    }
  }

  function stabiliseProduct(root) {
    if (!root || root.__lbxV25Stable) return;
    root.__lbxV25Stable = true;
    updateGalleryByColor(root);
    root.addEventListener('click', function (event) {
      if (event.target.closest && event.target.closest('.lbx-color-button')) {
        setTimeout(function () { updateGalleryByColor(root); }, 120);
        setTimeout(function () { updateGalleryByColor(root); }, 500);
      }
    });
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[id^="lbx-product-"]'), stabiliseProduct);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
